/**
 * Checks if the user can change the automatic responses status for a client
 * @param lastLeadStatus - The last lead status of the client
 * @returns True if the user can change the automatic responses status, false otherwise
 */
export default function canChangeAutomaticResponses(lastLeadStatus: string | null | undefined): boolean {
  return !['ASSIGNED_TO_SALESMAN', 'PENDING_TO_BE_HANDLED', 'PENDING_TO_BE_ASSIGNED', 'HANDLED_BY_SALESMAN'].includes(
    lastLeadStatus || ''
  );
}
